export function getInputFileUploadConstraints(modelSchema, inputKey) {
  const inputSchema = modelSchema?.input_schema?.properties?.[inputKey]
  const { allowedTypes = [], maxFileSize = 0 } = inputSchema || {}

  return { allowedTypes, maxFileSize }
}
